
export default {
  props: {
    product: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      currentSku: this.product.sku,
      variantId: null,
      activeVariant: null
    }
  },
  computed: {
    variant() {
      return this.product.variantsCount > 0
        ? this.activeVariant || this.product.variants[0]
        : this.product.master
    },
    inputAttrs() {
      return { textTransform: 'uppercase' }
    },
    buttonAttrs() {
      return {
        type: 'primary',
        borderRadius: 'none',
        textTransform: 'uppercase',
        message: true
      }
    }
  },
  methods: {
    onSetVariant(variant) {
      this.activeVariant = variant
      this.currentSku = variant.sku
      this.variantId = variant.id
    }
  }
}
